export default "__VITE_ASSET__v2UVT7vd__"